//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BrazeWrapper',
  props: ['additional_classes'],
  data() {
    return {
      open: false,
      cards: [],
      unsubscribeContentCards: null,
      isInitBraze: false
    }
  },
  computed: {
    hasUnread() {
      return this.cards.some(card => !card.viewed)
    },
    unreadCount() {
      return this.cards.filter(card => !card.viewed).length
    },
    isLoggedIn() {
      return this.user
    }
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(newValue) {
        if (newValue && this.$braze) {
          this.initializeBraze()
        }
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)

    if (typeof this.unsubscribeContentCards === 'function') {
      this.unsubscribeContentCards()
    }

    this.unsubscribeContentCards = null
  },
  methods: {
    initializeBraze() {
      if (this.isInitBraze) return
      this.isInitBraze = true

      const brazeUser = this.$braze.getUser()
      const emailSubscribed = this.user.accept_promo_via_email ? 'subscribed' : 'unsubscribed'
      const pushSubscribed = this.user.accepts_promo_popups ? 'subscribed' : 'unsubscribed'

      brazeUser?.setEmailNotificationSubscriptionType(emailSubscribed)
      brazeUser?.setPushNotificationSubscriptionType(pushSubscribed)

      this.$braze.logCustomEvent('IDENTIFIED_USER', { user_id: this.user.id })

      // Subscribe to Content Cards updates
      this.unsubscribeContentCards = this.$braze.subscribeToContentCardsUpdates(this.updateCards)
      this.$braze.requestContentCardsRefresh()

      // Optional: subscribe to in-app messages
      this.$braze.subscribeToInAppMessage(console.log)
      this.$braze.automaticallyShowInAppMessages()
    },

    toggleDropdown() {
      this.open = !this.open
    },

    handleClickOutside(e) {
      if (this.open && !this.$refs.brazeWrapper.contains(e.target)) {
        this.open = false
      }
    },

    updateCards() {
      let rawCards = []
      try {
        rawCards = this.$braze.getCachedContentCards()?.cards || []
      } catch (e) {
        console.error('Error fetching cached content cards:', e)
      }

      rawCards = rawCards
          .filter(c => !c.isControl)
          .filter(c => !c.dismissed)

      this.cards = rawCards.map(this.mapCard)

      if (this.open && this.cards.length === 0) this.open = false
    },

    mapCard(card) {
      return {
        id: card.id,
        title: card.title || 'No title',
        description: card.description || '',
        viewed: card.viewed,
        image: card.imageUrl || card.image || '',
        url: card.url,
        linkText: card.linkText || 'View',
        raw: card,
        cardType: this.getCardType(card, this.$braze)
      }
    },

    getCardType(card, braze) {
      if (!card) return 'null'

      if (braze?.ClassicCard && card instanceof braze.ClassicCard) return 'CLASSIC'
      if (braze?.CaptionedImageCard && card instanceof braze.CaptionedImageCard) return 'CAPTIONED_IMAGE'
      if ((braze?.Banner || braze?.ImageOnly) && (card instanceof braze.Banner || card instanceof braze.ImageOnly)) return 'BANNER'
      if (braze?.ControlCard && card instanceof braze.ControlCard) return 'CONTROL'

      const name = card.constructor?.name || typeof card
      const nameMap = {
        ClassicCard: 'CLASSIC',
        CaptionedImageCard: 'CAPTIONED_IMAGE',
        Banner: 'BANNER',
        ImageOnly: 'BANNER',
        ControlCard: 'CONTROL'
      }
      return nameMap[name] || name.toUpperCase?.() || name
    },

    handleCardClick(card) {
      if (this.$braze) {
        this.$braze.logContentCardClick?.(card.raw)
        this.$braze.logContentCardImpressions?.([card.raw])
        this.$braze.logContentCardDismissed?.(card.raw)
      }

      if (card.url) window.open(card.url, '_blank')

      this.cards = this.cards.map(c => (c.id === card.id ? { ...c, viewed: true } : c))
    },

    logImpression(card) {
      this.$braze?.logContentCardImpressions?.([card.raw])
    },

    removeCard(card) {
      // only dismiss if Braze says it's dismissible
      if (card?.raw?.dismissible) {
        this.$braze.logCardDismissal(card.raw)
      }

      // remove from UI immediately
      this.cards = this.cards.filter(c => c.id !== card.id)
      if (this.cards.length === 0) this.open = false

      // sync cache so it doesn't come back on next update
      this.$braze.requestContentCardsRefresh()
    }
  }
}
